<template>
  <!-- note: disabled AppToolBar and AppDrawer, see App.vue -->

  <div :style="{ height: `${windowHeight}px` }">
    <BaseControlBar
      style="
        height: 65px;
        top: 0;
        margin: 0 !important;
      "
    >
      <h1
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
      >
        掃描二維碼
      </h1>
    </BaseControlBar>

    <!-- scanner page -->
    <template v-if="coupon === null || redeemedItem === null">
      <div
        :style="{
          height: `calc(${windowHeight}px - 65px - 80px)`,
          display: 'grid',
          placeItems: 'center',
          background: '#444444'
        }"
      >
        <div
          v-if="cameraErrType === null"
          id="reader"
          style="width: 100%; height: 100%"
        ></div>
        <div
          v-else style="color: white;
          text-align: center;
          font-size: 1.25rem"
        >
          <template
            v-if="cameraErrType === CAMERA_ERROR_TYPE.UNKNOWN"
          >
            <p>出現了未知錯誤，</p>
            <p>請刷新此頁面重試。</p>
          </template>
          <template
            v-else-if="cameraErrType === CAMERA_ERROR_TYPE.NOT_FOUND"
          >
            <p>未偵測到相機，</p>
            <p>請使用流動裝置以掃描二維碼。</p>
          </template>
          <template
            v-else-if="cameraErrType === CAMERA_ERROR_TYPE.NOT_ALLOWED"
          >
            <p>無法存取您的相機，</p>
            <p>請重置瀏覽器的權限設定，</p>
            <p>然後刷新此頁面。</p>
          </template>
        </div>
      </div>

      <div
        style="
          width: 100%;
          height: 80px;
          position: fixed;
          bottom: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #fafdff;
        "
      >
        <span
          style="
            font-size: 0.75rem;
            color: #3A4047
          "
        >
          未能掃描二維碼？
        </span>
        <span
          @click="
            stopCamera();
            $bvModal.show('input-modal');
          "
          style="
            font-size: 1.25rem;
            font-weight: 500;
            color: #347ABA;
            cursor: pointer;
          "
        >
          手動輸入優惠碼
        </span>
      </div>

      <b-modal
        id="input-modal"
        centered
        hide-header
        hide-footer
        no-enforce-focus
        no-close-on-backdrop
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 1rem
          "
        >
          <h2 class="my-3">輸入優惠碼</h2>
          <div style="width: 100%" class="my-2">
            <ValidationObserver ref="form">
              <AGCInput
                v-model.trim="codeInput"
                name="優惠碼"
                rules="required|max:50"
                placeholder="請輸入優惠碼"
                required
                autofocus
              ></AGCInput>
            </ValidationObserver>
          </div>
          <div style="width: 100%; display: flex; gap: 1.5rem" class="my-2">
            <b-button
              @click="
                $bvModal.hide('input-modal');
                reset();
              "
              variant="outline-primary"
              style="flex: 1"
            >
              返回
            </b-button>
            <b-button
              @click="onInputModalSubmitClicked"
              variant="primary"
              style="flex: 1"
            >
              確認
            </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="error-modal"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 1rem
          "
        >
          <h2 class="my-3" style="text-align: center;">
            掃描失敗
          </h2>
          <p class="my-2">
            {{ redeemErr }}
          </p>
          <b-button
            @click="
              $bvModal.hide('error-modal');
              reset();
            "
            variant="outline-primary"
            style="width: 50%;"
            class="my-2"
          >
            返回
          </b-button>
        </div>
      </b-modal>
    </template>

    <!-- redeem result page -->
    <template v-else>
      <div v-show="!isLoading" class="coupon-info">
        <div class="coupon-detail">
          <div class="used-success-wrapper">
            <img class="qr-code" src="../../assets/img/qrcode/qrcode.png" />
            <div style="display: inline-block;">
              <span class="success-msg">
                掃描成功，已使用優惠
              </span>
              <div class="button-wrapper">
                <b-button
                  variant="outline-primary"
                  @click="$router.push({ name: 'ListScannedCoupons' })"
                >
                  使用紀錄
                </b-button>
                <b-button variant="primary" @click="reset">
                  繼續掃描
                </b-button>
              </div>
            </div>
            <div class="detail-wrapper">
              <span class="detail-header">詳細資料</span>
              <div class="group">
                <label>訂單編號</label>
                <span class="value" v-if="redeemedItem.paymentType === 'HKD'">
                  {{ redeemedItem.ref }}
                </span>
                <span class="value" v-else>
                  N/A (積分優惠券)
                </span>
              </div>
              <div class="group">
                <label>優惠名稱</label>
                <span class="value">
                  {{ coupon.name1 }}
                </span>
              </div>
              <div class="group">
                <label>優惠碼</label>
                <span class="value">
                  {{ coupon.code }}
                </span>
              </div>
              <div class="group">
                <label>購買數量（每個二維碼只供兌換一件貨品）</label>
                <span class="value">
                  {{ redeemedItem.quantity }}
                </span>
              </div>
              <div class="group" v-if="redeemedItem.price">
                <label>訂單價值</label>
                <span class="value">
                  {{ redeemedItem.price }}
                </span>
              </div>
              <div class="group">
                <label>交易日期</label>
                <span class="value">
                  {{ coupon.acquiredAt }}
                </span>
              </div>
              <div class="group">
                <label>兌換日期</label>
                <span class="value">
                  {{ coupon.usedAt }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- loading spinner overlay -->
    <LoadingSpinner v-show="isLoading"></LoadingSpinner>
  </div>
</template>

<script>
import BaseControlBar from '@/components/BaseControlBar.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import AGCInput from '@/components/form/AGCInput.vue';
import http from '@/helpers/new-http';
import formMixin from '@/mixins/form';
import { BButton } from 'bootstrap-vue';
import { Html5Qrcode, Html5QrcodeScannerState } from 'html5-qrcode';

const CAMERA_ERROR_TYPE = Object.freeze({
  UNKNOWN: 0,
  NOT_FOUND: 1,
  NOT_ALLOWED: 2,
});

export default {
  mixins: [formMixin],
  components: {
    BaseControlBar,
    LoadingSpinner,
    AGCInput,
    BButton,
  },
  data: () => ({
    // using innerHeight instead of 100vh to exclude mobile address bar
    windowHeight: window.innerHeight,
    camera: null,
    // to handle cases where we call stopCamera before it is started
    isUsingCamera: false,
    CAMERA_ERROR_TYPE,
    cameraErrType: null,
    codeInput: null,
    isLoading: false,
    redeemErr: null,
    redeemedItem: null,
    coupon: null,
  }),
  methods: {
    async reset() {
      this.redeemedItem = null;
      this.coupon = null;
      this.redeemErr = null;
      await this.stopCamera();
      await this.startCamera();
    },
    async startCamera() {
      this.isUsingCamera = true;
      this.camera = new Html5Qrcode('reader');
      const readerHTMLElement = document.querySelector('#reader');
      try {
        await this.camera.start(
          { facingMode: 'environment' },
          {
            fps: 10,
            qrbox: { width: 300, height: 300 },
            aspectRatio: readerHTMLElement.offsetHeight / readerHTMLElement.offsetWidth,
          },
          this.onQrCodeScanned,
        );
      } catch (err) {
        const match = err.match(/Not(Found|Allowed)Error/);
        if (match[1] === 'Found') {
          this.cameraErrType = CAMERA_ERROR_TYPE.NOT_FOUND;
        } else if (match[1] === 'Allowed') {
          this.cameraErrType = CAMERA_ERROR_TYPE.NOT_ALLOWED;
        } else {
          this.cameraErrType = CAMERA_ERROR_TYPE.UNKNOWN;
        }
      }
      if (!this.isUsingCamera) {
        this.stopCamera();
      }
    },
    async stopCamera() {
      this.isUsingCamera = false;
      if (this.camera !== null && this.camera.getState() === Html5QrcodeScannerState.SCANNING) {
        await this.camera.stop();
        this.camera.clear();
        this.camera = null;
      }
    },
    async onQrCodeScanned(decodedText) {
      this.stopCamera();
      this.isLoading = true;
      http(
        {
          method: 'POST',
          url: '/agc-sub-merchant-api/qrcode/scanQrCode',
          data: {
            token: decodedText,
          },
        },
        {
          error: ({ data: { msg } }) => {
            this.redeemErr = msg;
            this.$bvModal.show('error-modal');
          },
          next: (payload) => {
            this.coupon = payload.result.coupon;
            this.redeemedItem = payload.result.redeemedItem;
          },
          complete: () => {
            this.isLoading = false;
          },
        },
      ).toPromise();
    },
    async onInputModalSubmitClicked() {
      if ((await this.validate().toPromise()) === undefined) {
        return;
      }
      this.$bvModal.hide('input-modal');
      this.isLoading = true;
      http(
        {
          method: 'POST',
          url: '/agc-sub-merchant-api/qrcode/inputCode',
          data: {
            code: this.codeInput,
          },
        },
        {
          error: ({ data: { msg } }) => {
            this.redeemErr = msg;
            this.$bvModal.show('error-modal');
          },
          next: (payload) => {
            this.coupon = payload.result.coupon;
            this.redeemedItem = payload.result.redeemedItem;
          },
          complete: () => {
            this.codeInput = null;
            this.isLoading = false;
          },
        },
      ).toPromise();
    },
  },
  mounted() {
    this.startCamera();
  },
  beforeRouteLeave(to, from, next) {
    this.stopCamera();
    next();
  },
};
</script>
<style lang="scss" scoped>
  .coupon-info {
    display: inline-block;
    box-sizing: border-box;
    padding: 15px 10px;
    margin: 2% 4%;
    border-radius: 5px;
    width: 92%;
    text-align: center;
    img.qr-code {
      width: 200px;
      display: inline-block;
    }
    .coupon-detail {
      .used-success-wrapper {
        text-align: center;
        background: #fff;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 5px;
        span.success-msg {
          display: inline-block;
          width: 100%;
          color: #3379ba;
          font-size: 18px;
          padding: 10px 0px;
        }
        .button-wrapper {
          text-align: center;
          width: 100%;
          display: inline-block;
          button {
            width: 144px;
            display: inline-block;
            height: 41px;
            margin: 7px;
          }
        }
        .detail-wrapper {
          text-align: left;
          padding: 10px 10px;
          .detail-header {
            color: #3a4047;
            font-size: 16px;
            margin-bottom: 15px;
            display: inline-block;
          }
          .group {
            margin-bottom: 15px;
            font-size: 14px;
            label {
              color: #174169;
            }
            span.value {
              color: #3a4046;
              width: 100%;
              display: inline-block;
            }
          }
        }
      }
    }
    .used-failed-wrapper {
      text-align: center;
      background: #fff;
      padding: 5%;
      border-radius: 5px;
      img.qr-code {
        width: 200px;
        display: inline-block;
      }
      span.failed-msg {
        color: #ff4300;
      }
      button {
        width: 144px;
        display: inline-block;
        height: 41px;
        margin: 7px;
      }
    }
  }
</style>
